import { useEffect, useState } from "react";
import {
  TournamentListBoxWrapper,
  TournamentListDataItem,
  TournamentListDataItemWrapper,
  TournamentListDataWrapper,
  TournamentListHeaderItemWrapper,
  TournamentListHeaderWrapper,
  TournamentListSearchInputBox,
  TournamentListSearchWrapper,
  TournamentListWrapper,
} from "./styles/tournament-list.style";
import {
  getTournamentNotEndByCafeId,
  TournamentResponse,
} from "../../../../api/tournament";
import { pubState } from "../../../../recoil/pub.atom";
import { useRecoilValue } from "recoil";
import { usePosterContext } from "../../context/poster-context";
import Pagination from "../../../../component/Pagination";
import {
  getStructurePresetsByCafeId,
  StructurePresetResponseDto,
} from "../../../../api/tournament-preset";
import { getTournamentTypeName } from "../../../../utils/tournament-type";
import DropBox from "../../../../component/DropBox";

const TournamentList = () => {
  const pub = useRecoilValue(pubState);

  const { setSelectedTournament } = usePosterContext();

  const [list, setList] = useState<TournamentResponse[]>([]);
  const [resultList, setResultList] = useState<TournamentResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const itemsPerPage = 10;
  const [presetList, setPresetList] = useState<
    { name: string; value: string }[]
  >([]);

  //종료 안된 토너먼트 리스트 호출
  const getList = async () => {
    if (!pub) return;
    const res = await getTournamentNotEndByCafeId(pub.id);
    // createdAt 최신순으로 정렬
    const sortedRes = res.sort((a, b) => {
      const dateA = new Date(a.createdAt).getTime();
      const dateB = new Date(b.createdAt).getTime();
      return dateB - dateA; // 내림차순 (최신순)
    });
    setResultList(
      sortedRes.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      ),
    );
    setList(sortedRes);
    setTotalPages(Math.max(1, Math.ceil(sortedRes.length / itemsPerPage)));
  };

  const handlePageChangeOrSearch = () => {
    const filteredList = list.filter((item) => item.title.includes(search));
    setResultList(
      filteredList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      ),
    );
    setTotalPages(Math.max(1, Math.ceil(filteredList.length / itemsPerPage)));
  };

  useEffect(() => {
    handlePageChangeOrSearch();
  }, [currentPage, search]);

  useEffect(() => {
    getList();
  }, []);

  const convertCreatedAt = (createdAt: string) => {
    // YYYY.MM.DD
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
  };
  const convertStartDate = (startDate: string) => {
    // YYYY.MM.DD / HH:MM
    return startDate.split(" ").slice(0, 2).join(" / ");
  };

  const handleItemClick = (item: TournamentResponse) => {
    setSelectedTournament(item);
  };

  const getPreset = async () => {
    if (!pub) return;
    const res = await getStructurePresetsByCafeId(pub.id, 1, 100);
    setPresetList(
      res.preset.map((item) => ({
        name: `(${handlePresetType(item)}) ${item.presetName}`,
        value: item.preset,
      })),
    );
  };

  useEffect(() => {
    getPreset();
  }, [pub]);

  const handlePresetType = (item: StructurePresetResponseDto) => {
    const preset = JSON.parse(item.preset);
    return getTournamentTypeName(preset.tournamentType);
  };

  // 프리셋 토너먼트 타입
  const handlePresetClick = (value: string) => {
    const tournament = JSON.parse(value);
    setSelectedTournament(tournament);
  };

  return (
    <TournamentListWrapper>
      <TournamentListSearchWrapper>
        <TournamentListSearchInputBox>
          <input
            type="text"
            placeholder="토너먼트 이름을 검색하세요"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <img src="/image-web/poster/search.svg" alt="search" />
        </TournamentListSearchInputBox>
        <DropBox
          list={presetList}
          value={null}
          setValue={handlePresetClick}
          label={"토너먼트 프리셋 목록"}
        />
      </TournamentListSearchWrapper>
      <TournamentListBoxWrapper>
        <TournamentListHeaderWrapper>
          <TournamentListHeaderItemWrapper width="80px">
            등록 일자
          </TournamentListHeaderItemWrapper>
          <TournamentListHeaderItemWrapper width="275px">
            토너먼트 이름
          </TournamentListHeaderItemWrapper>
          <TournamentListHeaderItemWrapper width="161px">
            토너먼트 시간
          </TournamentListHeaderItemWrapper>
        </TournamentListHeaderWrapper>
        <TournamentListDataWrapper>
          {resultList.map((item) => (
            <TournamentListDataItemWrapper
              key={item.id}
              onClick={() => handleItemClick(item)}
            >
              <TournamentListDataItem width="80px">
                {convertCreatedAt(item.createdAt)}
              </TournamentListDataItem>
              <TournamentListDataItem width="275px">
                {item.title}
              </TournamentListDataItem>
              <TournamentListDataItem width="161px">
                {convertStartDate(item.startDate)}
              </TournamentListDataItem>
            </TournamentListDataItemWrapper>
          ))}
        </TournamentListDataWrapper>
      </TournamentListBoxWrapper>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </TournamentListWrapper>
  );
};

export default TournamentList;
